export default __webpack_public_path__ + "static/media/maduro.37305a77.png";